export const DrawTrend = function (width, positionArr, height) {
    if (!positionArr.length) {
        return;
    }
    var $canvas = document.getElementById('brick-trend');
    if (!$canvas) {
        return;
    }
    var ctx = $canvas.getContext('2d');
    $canvas.width = width;
    ctx.lineWidth = 2;
    var index = positionArr.length;
    var maxY = Math.max.apply(null, positionArr.map(function (position) {
        return position[1];
    }));
    var containerHeight = $canvas.parentElement ? $canvas.parentElement.scrollHeight : 0;
    $canvas.height = Math.max(containerHeight, maxY + 20);
    for (var i = 0, len = positionArr.length; i < len; i++) {
        if (i == 0) {
            ctx.moveTo(positionArr[i][0], positionArr[i][1]);
        } else {
            ctx.lineTo(positionArr[i][0], positionArr[i][1]);
        }
        if (i == len - 1) {
            ctx.strokeStyle = '#ff621d';
            ctx.stroke();
        }
    }
}
export const clearCanvas = function () {
    var $canvas = document.getElementById('brick-trend');
    var ctx = $canvas.getContext('2d')
    ctx.clearRect(0, 0, $canvas.width, $canvas.height);

}


//////////////////
// WEBPACK FOOTER
// ./src/pages/lotteryopen/brick-trend/birck-trend.js
// module id = 703
// module chunks = 0